import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
type Props = {
  header: React.ReactNode;
  children: React.ReactNode;
  defaultOpen?: boolean;
};
export function Accordion({
  header,
  children,
  defaultOpen = false
}: Props) {
  const [open, setOpen] = useState(defaultOpen);
  return <div className="overflow-hidden rounded-xl border border-white/10 bg-white shadow-sm" data-id="element-16" data-mp="28d87s1p45wjg">
      <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} className="flex w-full items-center gap-3 px-4 py-3.5 text-left" data-id="element-17" data-mp="2n61ykj9u5z3f">
        <span className="flex-1 text-sm font-bold text-[#0f2c4a]" data-id="element-18" data-mp="2w3uffrv7hesx">{header}</span>
        <ChevronDownIcon className={`h-5 w-5 flex-shrink-0 text-[#8bc34a] transition-transform ${open ? "rotate-180" : ""}`} data-id="element-19" data-mp="2s4d8sv41mbm6" />
      </button>
      <AnimatePresence initial={false} data-id="element-20" data-mp="xq2l4pz6pnhz">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: "auto",
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: "easeInOut"
      }} data-id="element-21" data-mp="3g43ymw0qsux0">
            <div className="border-t border-slate-100 px-4 pb-4 pt-3" data-id="element-22" data-mp="3q18j8rexwibp">{children}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}